import $ from 'jquery';


export default function initializeNavigation() {
    $(".avu-nav-news-inner-container").click(function(){
        let url = $(".avu-news-link").attr("href");
        if (url) {
            window.location.href = url;
        }
    });
}


